var $5b66781a381525da$exports = {};
let $5b66781a381525da$var$isClicked = false;
function $5b66781a381525da$var$hoverImg(element) {
    // element.setAttribute('src', './images/copyed_icon.png');
    element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copyed_icon.png');
}
function $5b66781a381525da$var$removehoverImg(element) {
    // !isClicked &&	element.setAttribute('src', './images/copy_icon.png');
    !$5b66781a381525da$var$isClicked && element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copy_icon.png');
}
function $5b66781a381525da$var$doneCopy(element) {
    let mailBtn = document.querySelector('#mail_btn');
    // let careerMailData = document.getElementById('career_mail').innerHTML = 'careers@quokkalabs.com'
    let careerMailData = document.getElementById('career_mail').innerText;
    // console.log(careerMailData);
    mailBtn.addEventListener('click', ()=>{
        navigator.clipboard.writeText(careerMailData).then(()=>{
            console.log('Text copied to clipboard');
        }).catch((err)=>{
            console.error('Failed to copy text: ', err);
        });
    });
    // element.setAttribute('src', './images/copy_done.png');
    element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copy_done.png');
    $5b66781a381525da$var$isClicked = true;
    setTimeout(()=>{
        $5b66781a381525da$var$isClicked = false;
        // element.setAttribute('src', './images/copy_icon.png')
        element.setAttribute('src', 'https://cdn.quokkalabs.com/ql-images/copy_icon.png');
    }, 2000);
    return $5b66781a381525da$var$isClicked;
}
window.hoverImg = $5b66781a381525da$var$hoverImg;
window.removehoverImg = $5b66781a381525da$var$removehoverImg;
window.doneCopy = $5b66781a381525da$var$doneCopy;


//# sourceMappingURL=careers.de21028e.js.map
